import { Badge as MuiBadge } from '@material-ui/core';
import type { BadgeProps } from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';

import { colors, fonts } from '../styles';

// https://material-ui.com/api/badge/
// Badges wrap the element on which it'll be displayed

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Badge = withStyles({
  badge: {
    backgroundColor: colors.error.default,
    color: colors.white,
    fontSize: fonts.size.tiny,
    fontWeight: fonts.weight.bold,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '100%',
    height: '16px',
    minWidth: '16px',
    padding: '5px',
  },
})((props: BadgeProps) => (
  <MuiBadge max={999} {...props} overlap='rectangular'>
    {props.children}
  </MuiBadge>
));
